import React, { useEffect, useState } from "react";
import ApproveButton from "../../common/ApproveButton";
// import Header from "../../Header";
// import warrobots from "../../Image/warrobots.png";
// import Footer from "../../Footer";
import {
  WETHX_TOKEN_ADDRESS,
  WETH_TOKEN_ADDRESS,
  POTION_DAO_STAKING_ADDRESS,
  PTN_TOKEN_ADDRESS,
  UNISWAP_ROUTER_ADDRESS,
  BNB_ORACLE
} from "../../../Config/index";
import POTION_DAO_STAKING_ABI from "../../../Config/POTION_DAO_STAKING_ABI.json";

import BNBORACLEABI from "../../../Config/BNBORACLE.json";

import Pancake from "../../../Config/UniswapRouter.json";
import IUniswapv2Pair from "../../../Config/IUniswapv2Pair.json";

// import MMFX_TOKEN from "../../../Config/MMFX_TOKEN.json";
// import { MMFX_TOKEN_ADDRESS } from "../../../Config";

import { useAccount, useBalance, useContractRead } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import Button from "@mui/material/Button";
import { Box, TextField } from "@mui/material";
import useCustomContractRead from "../../../Hooks/useCustomContractRead";
import Symbol from "../../Symbol/Symbol";
import convertWeiToEther from "../../../Utils/convertWeiToEther";
import useCustomContractWrite from "../../../Hooks/useCustomContractWrite";
import convertEtherToWei from "../../../Utils/convertEtherToWei";
import Loader from "../../Loader/Loader";
// import Stake from "../../Staking/Stake";
// import Lock from "../../Staking/Lock";
// import WithdrawModal from "./WithdrawModal";
import { makeStyles } from "@mui/styles";
import style from "./staking.module.css";
import { log } from "util";
import useCheckAllowance from "../../../Hooks/useCheckAllowance";
import WithdrawModal from "./WithdrawModal";
import {  ethers } from "ethers";
import { NewFooter } from "../../NewFooter";


const useStyles = makeStyles({
  root: {
    overflowY: "auto",
    height: "200px",
    "@media(max-width  : 1200px)": {
      overflowY: "auto",
    },
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      background: "#272522",
    },
  },
});

export default function Staking() {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputValueWithdraw, setInputValueWithdraw] = useState("");

  const [isAproveERC20, setIsApprovedERC20] = useState(false);
  const [inputValuelock, setInputValuelock] = useState("");
  const [isStaked, setIsStaked] = useState(true);
  
  let alienPrice = 0;
  const { data: _alienPrice  } = useCustomContractRead({
    Adrress: BNB_ORACLE,
    Abi: BNBORACLEABI,
    FuncName: "latestAnswer",
    // onSuccess:(data)=>{
    //   alienPrice = ethers.utils.formatUnits(data, 8);
    // }
  });
  alienPrice = _alienPrice ? ethers.utils.formatUnits(_alienPrice, 8) : 1;

  const stackhandleInputChange = (event) => {
    const { value } = event.target;
    const isStack = /^[0-9]*(\.[0-9]{0,18})?$/.test(value);
    if (isStack) {
      setInputValue(value);
    }
  };
  const stackhandleInputChangeWithdraw = (event) => {
    const { value } = event.target;
    const isStack = /^[0-9]*(\.[0-9]{0,18})?$/.test(value);
    if (isStack) {
      setInputValueWithdraw(value);
    }
  };

  const setMax = (value) => {
    const isStack = /^[0-9]*(\.[0-9]{0,2})?$/.test(value);
    if (isStack) {
      setInputValue(value);
    }
  };

  const setMaxLock = (value) => {
    const isStack = /^[0-9]*(\.[0-9]{0,2})?$/.test(value);
    if (isStack) {
      setInputValuelock(value);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const { address, isConnected } = useAccount();
  const [lockDuration, setlockDuration] = useState(0);
  const [totalClaimableRewards, setTotalClaimableRewards] = useState("0");
  const [totalClaimableRewardsBNB, setTotalClaimableRewardsBNB] = useState("0");
  const [totalEarlyClaimableRewards, setTotalEarlyClaimableRewards] =
    useState("0");
  const [earlyPenalty, setearlyPenalty] = useState("0");

  // //console.log(
  //   "totalClaimableRewards",
  //   totalClaimableRewards,
  //   totalEarlyClaimableRewards
  // );

  const [potionPrice, setPotionPrice] = useState(0);
  const { data: getAmountOutFoMinati } = useCustomContractRead({
    Adrress: "0xA976a4ba5076f1264e0f8fFB5b9ff4aC9Fd615fa",
    Abi: IUniswapv2Pair,
    FuncName: "getReserves",
    onSuccess: (data) => {
      // //console.log("rate", data);
      // let _ptn = Number(data[0]);
      // let _weth = Number(data?.[1]) * Number(alienPrice);
      // let _price = parseFloat(_weth / _ptn).toFixed(9);
      // setPotionPrice(_price);
    },
  });
  useEffect(() => {
      if(getAmountOutFoMinati && alienPrice) {
        let _ptn = Number(getAmountOutFoMinati[1]);
      let _weth = Number(getAmountOutFoMinati?.[0]) * Number(alienPrice);
      let _price = parseFloat(_weth / _ptn).toFixed(9);
       if (!Number(_price)) {
        setPotionPrice(0)
       } else {
        setPotionPrice(_price);
       }
        // console.log("pricerate", _ptn,_weth,_price.toNumber(), alienPrice);
      }
    }, [getAmountOutFoMinati, alienPrice ])
    // console.log("potionprice", potionPrice);
    
  

  const { openConnectModal } = useConnectModal();
  const { data: mntBalance } = useBalance({
    address: address,
    token: PTN_TOKEN_ADDRESS,
    watch: true
  });
  

  const { data: stakeLockDuration } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "lockDuration",
  });
  

  const lockhandleInputChange = (event) => {
    const { value } = event.target;
    const isLock = /^[0-9]*(\.[0-9]{0,2})?$/.test(value);

    if (isLock) {
      setInputValuelock(value);
    }
  };

  const {
    _useContractWrite: lockContractWrite,
    _useWaitForTransaction: lockWaitForTransaction,
  } = useCustomContractWrite({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "stake",
    Args: [
      convertEtherToWei?.(inputValuelock === "" ? "0" : inputValuelock),
      true,
    ],
    isEnabled:
      parseFloat?.(inputValuelock === "" ? "0" : inputValuelock) > 0 &&
      parseFloat?.(inputValuelock) <= parseFloat?.(mntBalance?.formatted) &&
      isAproveERC20,
  });

  const { data: claimableRewards } =  useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "claimableRewards",
    Args: [address],
    isEnabled: address !== undefined,
    onSuccess: (data) => {
      let total1 = convertWeiToEther?.(data?.[0]?.[1]);
      let total2 = convertWeiToEther?.(data?.[1]?.[1]);

      setTotalClaimableRewards?.(total1);
      setTotalClaimableRewardsBNB?.(total2);
    },
  });

  useEffect(() => {
   if (claimableRewards) {
    let total1 = convertWeiToEther?.(claimableRewards?.[0]?.[1]);
    let total2 = convertWeiToEther?.(claimableRewards?.[1]?.[1]);

    setTotalClaimableRewards?.(total1);
    setTotalClaimableRewardsBNB?.(total2);
   }
  }, [claimableRewards])
  



  // //console.log("hihih",totalClaimableRewards?.toString(), totalClaimableRewardsBNB?.toString());
  const {
    executeWrite: stakeContractWrite,
    isLoading: isLoadingStake,
    isSuccess: isSuccessStake,
    isError: isErrorStake,
    error: errorStake,
    txHash: stakeWaitForTransaction
  } = useCustomContractWrite({
    address: POTION_DAO_STAKING_ADDRESS,
    abi: POTION_DAO_STAKING_ABI,
    functionName: "stake",
    args: [convertEtherToWei?.(inputValue === "" ? "0" : inputValue), false],
    isEnabled:
      parseFloat?.(inputValue === "" ? "0" : inputValue) > 0 &&
      parseFloat?.(inputValue ?? 0) <= parseFloat?.(mntBalance?.formatted) &&
      isAproveERC20,
  });

  // console.log("isLoadingStake", isLoadingStake, isSuccessStake, isErrorStake, errorStake, stakeWaitForTransaction);
  



  const { data: _rewardData } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    Args: [PTN_TOKEN_ADDRESS],
    FuncName: "rewardData",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });


  const { data: _rewardDataStake } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    Args: [WETH_TOKEN_ADDRESS],
    FuncName: "rewardData",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });

  const { data: _rewardDataLocked } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    Args: [WETHX_TOKEN_ADDRESS],
    FuncName: "rewardData",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });

  const { data: _rewardsDuration } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "rewardsDuration",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });  

  const { data: totalLockedSupply } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "lockedSupply",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });

  const { data: totalStakedSupply } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "totalSupply",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });

  const { data: lockedBalances } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "lockedBalances",
    Args: [address],
    isEnabled: address !== undefined,
    // onSuccess:(data)=>{
    //   //console.log(data?.total?.toString());
    // }
  });
  

  const { data: lockedSupply } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "lockedSupply",
    isEnabled: address !== undefined,
    // onSuccess:(data)=>{
    //   //console.log(data?.total?.toString());
    // }
  });

  const { data: unlockedBalance } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "unlockedBalance",
    Args: [address],
    isEnabled: address !== undefined,
    // onSuccess:(data)=>{
    //   //console.log(data?.total?.toString());
    // }
  });


  const {
    executeWrite: withdrawContract,
    isLoading: isLoadingWithdraw,
    isSuccess: isSuccessWithdraw,
    isError: isErrorWithdraw,
    error: errorWithdraw,
    txHash: withdrawWaitForTransaction
  } = useCustomContractWrite({
    address: POTION_DAO_STAKING_ADDRESS,
    abi: POTION_DAO_STAKING_ABI,
    functionName: "withdraw",
    args: [
      convertEtherToWei?.(inputValueWithdraw === "" ? "0" : inputValueWithdraw),
    ],
    isEnabled:
      address !== undefined &&
      parseFloat?.(inputValueWithdraw === "" ? "0" : inputValueWithdraw) > 0 &&
      parseFloat?.(inputValueWithdraw === "" ? "0" : inputValueWithdraw) <=
        parseFloat?.(convertWeiToEther?.(unlockedBalance?.toString())),
  });

  // Function to set value based on percentage
  const handlePercentageClick = (percentage) => {
    if (mntBalance) {
      const balance = ethers.utils.parseUnits(mntBalance.formatted, mntBalance.decimals); // Convert to BigNumber
      const percentageValue = balance.mul(percentage).div(100); // Calculate percentage
      const formattedValue = ethers.utils.formatUnits(percentageValue, mntBalance.decimals); // Format back to string
      setInputValue(formattedValue); // Update state with the precise value
    }
  };

  // Function to set value based on percentage
  const handlePercentageClickWithdraw = (percentage) => {
    if (unlockedBalance) {
      const balance = ethers.utils.parseUnits(unlockedBalance?.toString(), 0);
      const value = balance.mul(percentage).div(100);
      const formattedValue = ethers.utils.formatUnits(value, 18);
      setInputValueWithdraw(formattedValue)
    }
  };

  const { data: earnedBalances } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "earnedBalances",
    Args: [address],
    isEnabled: address !== undefined,
    onSuccess: (data) => {
      // setTotalEarlyClaimableRewards(
      //   parseFloat?.(totalClaimableRewards) +
      //     parseFloat?.(convertWeiToEther?.(data?.total?.toString()))
      // );
    },
  });

  const { data: _withdrawablebalance } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "withdrawableBalance",
    Args: [address],
    isEnabled: address !== undefined,
    onSuccess: (data) => {
      setTotalEarlyClaimableRewards(
        convertWeiToEther?.(data?.amount?.toString())
      );
      setearlyPenalty(convertWeiToEther?.(data?.penaltyAmount?.toString()));
    },
  });
  //console.log("_withdrawablebalance", _withdrawablebalance);

  const {
    _useContractWrite: getRewardContract,
    _useWaitForTransaction: getRewardWaitForTransaction,
  } = useCustomContractWrite({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "getReward",
    isEnabled: address !== undefined && parseFloat?.(totalClaimableRewards) > 0,
  });

  const {
    executeWrite: withdrawExpiredLocksContract,
    isLoading: isLoadingMint,
    isSuccess: isSuccessMint,
    isError: isErrorMint,
    error: errorMint,
    txHash: withdrawExpiredLocksWaitForTransaction
  } = useCustomContractWrite({
    address: POTION_DAO_STAKING_ADDRESS,
    abi: POTION_DAO_STAKING_ABI,
    functionName: "withdrawExpiredLocks",
    isEnabled:
      address !== undefined && parseFloat?.(lockedBalances?.[1]) > 0,
  });

  const {
    _useContractWrite: emergencyWithdrawContract,
    _useWaitForTransaction: emergencyWithdrawWaitForTransaction,
  } = useCustomContractWrite({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "emergencyWithdraw",
    isEnabled:
      address !== undefined && parseFloat?.(totalEarlyClaimableRewards) > 0,
  });

  const classes = useStyles();

  const getApr = () => {
    const rewardRate = convertWeiToEther(_rewardDataStake?.[1]);
    const rewardDuration = Number(_rewardsDuration) || 0;
    const days = rewardDuration / 86400;
    const amount = convertWeiToEther(totalStakedSupply) * potionPrice;
    const rewardInUsd = Number(rewardRate) * Number(alienPrice);
    return ((rewardInUsd * rewardDuration) / amount) * (365 / days) * 100;
  };
  

  // const BNB="0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
  // const BUSD="0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee"

  // const _rateA = 1;
  // const _rateB = 1;
  const minatiPrice = 0.0006358; // $ hard coded value
  useEffect(() => {
    getLockerApr();
  }, []);
  // const { data: _rateB } = useCustomContractRead({
  //   Adrress: UNISWAP_ROUTER_ADDRESS,
  //   Abi: Pancake,
  //   FuncName: "getAmountOut",
  //   isEnabled: true,
  //   Args: [("1000000000000000000")?.toString(),[WETH_TOKEN_ADDRESS, BNB]]

  // })

  // const { data: _rateA } = useCustomContractRead({
  //   Adrress: UNISWAP_ROUTER_ADDRESS,
  //   Abi: Pancake,
  //   FuncName: "getAmountOut",
  //   isEnabled: true,
  //   Args: [("1000000000000000000")?.toString(),[PTN_TOKEN_ADDRESS, BNB]]

  // })

  // //console.log(_rateA);

  // const { data: _rateUsd } = useCustomContractRead({
  //   Adrress: UNISWAP_ROUTER_ADDRESS,
  //   Abi: Pancake,
  //   FuncName: "getAmountOut",
  //   Args: [("1000000000000000000")?.toString(),[BNB, BUSD]]

  // })

  const { data: checkAllowance } = useCheckAllowance({
    tokenAddress: PTN_TOKEN_ADDRESS,
    spenderAddress: POTION_DAO_STAKING_ADDRESS,
    isLpToken: false,
  });
  

  useEffect(() => {
    if (address) {
      const price = parseFloat?.(inputValue === "" ? "1" : inputValue);
      const allowance = parseFloat?.(convertWeiToEther?.(checkAllowance));
      if (allowance >= price) {
        setIsApprovedERC20(true);
      } else {
        setIsApprovedERC20(false);
      }
    }
  }, [checkAllowance, address, inputValue]);
  
  
  const getLockerApr = () => {
    // const rewardRate = convertWeiToEther(_rewardData?.[1]);
    // const rewardLockedRate = convertWeiToEther(_rewardDataLocked?.[1]);
    // const rewardDuration = Number(_rewardsDuration) || 0;
    // const amountA = Number(rewardRate) * rewardDuration;
    // const amountB = Number(rewardLockedRate) * rewardDuration;
    // const valueA = amountA * Number(potionPrice);
    // const valueB = Number(amountB) * Number(alienPrice);
    // const valueD = 100 * Number(potionPrice);
    // const days = rewardDuration / 86400;
    // return (valueA + valueB / valueD) * (365 / (days * 4)) * 100;

    return getApr()*2
  };
  

  return (
    <main className={style.staking}>
      <div className="d-flex justify-content-center align-items-center pt-5" style={{minHeight:"calc(100vh - 180px"}}>
        {/*LEFT CONTENT */}
        {/* <div className={style.staking_left + " col-lg-4 col-12 "}> */}
          {/* Start left stacking code */}
          <div className={style.stake + " "}>
            <div className="d-flex align-items-center justify-content-between">
              <div
                className={`${style.tab_btns} d-flex gap-sm-3 align-items-center`}
              >
                <button
                  className={`border-0 bg-transparent fw-600 ${
                    isStaked ? style.active : ""
                  }`}
                  onClick={() => setIsStaked(true)}
                >
                  Stake
                </button>
                <button
                  className={`border-0 bg-transparent fw-600 ${
                    !isStaked ? style.active : ""
                  }`}
                  onClick={() => setIsStaked(false)}
                >
                  Withdraw
                </button>
              </div>
              <div
                className={`${style.info_div} position-relative d-flex justify-content-center align-items-center tooltip-parent`}
              >
                <img src="/icons/info.svg" alt="" />
                <p className="info-tooltip position-absolute fw-normal" style={{width:"220px"}}>
                  Includes staked balance and unlocked vestings.
                </p>
              </div>
            </div>

            {/* CARD CONTENT  */}

            <div className={`${style.card_content_body}`}>
              {
                isStaked ? (
                  // Start staked code
                  <div>
                    <div
                      className={`${style.total_stcked_box} my-4 d-flex align-items-center justify-content-between`}
                    >
                      <span>Total Staked</span>
                      <div className="d-flex gap-2 align-items-center">
                        <div className={`${style.bg_circle_lgold} `}>
                          <img src="/icons/logo.svg" alt="" />
                        </div>
                        <p className="mb-0"> 
                          {parseFloat?.(
                            convertWeiToEther?.(unlockedBalance?.toString())
                          ).toFixed(2)}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="my-4 mt-5">
                      <div className="d-flex justify-content-between">
                        <span>Balance</span>
                        <p className="mb-1">
                          {parseFloat?.(mntBalance?.formatted)
                            ? parseFloat?.(mntBalance?.formatted).toFixed(2)
                            : "0.0"}
                          SHiELD
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span
                          className="color-gray"
                          style={{ marginRight: "10px" }}
                        >
                          APR
                        </span>
                        <p className="mb-0">
                          {parseFloat(_rewardDataStake ? getApr() : 0).toFixed(
                            2
                          ) || 0}
                          %{/* <span className="text-uppercase">BNB</span> */}
                        </p>
                      </div>
                    </div>
                    <div className={style.form_stake}>
                      {/* <div className="d-flex my-3">
                    <input
                      type="number"
                      placeholder="0.00"
                      className="flex-grow-1"
                      value={inputValue}
                      onChange={stackhandleInputChange}
                    />
                    <div className="d-flex gap-2 align-items-center">
                      <button
                        onClick={() => {
                          setMax(
                            parseFloat?.(mntBalance?.formatted)
                              ? parseFloat?.(mntBalance?.formatted).toFixed(2)
                              : "0.00"
                          );
                        }}
                        className="btn3 p-1 py-0"
                        style={{ fontSize: "12px" }}
                      >
                        Max
                      </button>
                      <div className="p-1 d-flex justify-content-center align-items-center">
                        <img src="/icons/logo.svg" alt="" />
                      </div>
                    </div>
                  </div> */}
                      <div className="my-3 d-flex flex-column justify-content-between">
                        <input
                          type="number"
                          placeholder="0.00"
                          className="flex-grow-1"
                          value={inputValue}
                          onChange={stackhandleInputChange}
                        />
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center gap-2">
                            <button
                              className="bg-white"
                              onClick={() => handlePercentageClick(10)}
                            >
                              10%
                            </button>
                            <button
                              className="bg-white"
                              onClick={() => handlePercentageClick(25)}
                            >
                              25%
                            </button>
                            <button
                              className="bg-white"
                              onClick={() => handlePercentageClick(50)}
                            >
                              50%
                            </button>
                            <button
                              className="bg-white"
                              onClick={() => handlePercentageClick(75)}
                            >
                              75%
                            </button>
                          </div>
                          <div>
                            {" "}
                            <button
                              className={`btn1 ${style.max_btn}`}
                              onClick={() => handlePercentageClick(100)}
                            >
                              Max
                            </button>
                          </div>
                        </div>
                      </div>
                      {/* <button className=" py-3 w-100" onClick={openConnectModal}>connect</button> */}
                      {isConnected && address ? (
                        <Box>
                          {!isAproveERC20 ? (
                            <ApproveButton
                              tokenAddress={PTN_TOKEN_ADDRESS}
                              spenderAddress={POTION_DAO_STAKING_ADDRESS}
                              setIsApprovedERC20={setIsApprovedERC20}
                              color="white"
                            />
                          ) : parseFloat?.(inputValue) >
                            parseFloat?.(mntBalance?.formatted) ? (
                            <button className="btn1 w-100 py-3">
                              Insufficient Fund
                            </button>
                          ) : (
                            <Button
                              disabled={
                                parseFloat?.(inputValue) > 0 &&
                                 
                                !isLoadingStake
                                  ? false
                                  : true
                              }
                              onClick={async () => {
                                try {
                                  await stakeContractWrite();
                                  setInputValue(0);
                                } catch (error) {
                                  //console.log(error);
                                }
                              }}
                              sx={{
                                gap: "10px !important",
                                "&.Mui-disabled": {
                                  cursor: "not-allowed !important",
                                  pointerEvents: "auto !important",
                                },
                                backgroundColor: "var(--main-color)",
                                fontSize: "14px",
                                fontFamily: "var(--font-pop)",
                                fontWeight: "700",
                                color: "var(--light)",
                                borderRadius: "12px",
                              }}
                              className="btn1 w-100 py-3"
                            >
                              {(
                                isLoadingStake) && (
                                <Loader color="#423A2A" />
                              )}
                              Stake
                            </Button>
                          )}
                        </Box>
                      ) : (
                        <button
                          onClick={openConnectModal}
                          className="btn1 w-100 py-3"
                        >
                          Connect wallet
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  // {/* End stacked code  */}
                  // Start withdraw code
                  <div>
                    <div
                      className={`${style.total_stcked_box} my-4 d-flex align-items-center justify-content-between`}
                    >
                      <span>Total Withdraw</span>
                      <div className="d-flex gap-2 align-items-center">
                        <div className={`${style.bg_circle_lgold} `}>
                          <img src="/icons/logo.svg" alt="" />
                        </div>
                        <p className="mb-0">
                          <p className="mb-0">
                            {parseFloat?.(
                              convertWeiToEther?.(unlockedBalance?.toString())
                            ).toFixed(2)}{" "}
                          </p>
                        </p>
                      </div>
                    </div>
                    <div className="my-4 mt-5">
                      <div className="d-flex justify-content-between">
                        <span>Balance</span>
                        <p className="mb-1">
                          {parseFloat?.(mntBalance?.formatted)
                            ? parseFloat?.(mntBalance?.formatted).toFixed(2)
                            : "0.0"}
                          SHiELD
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span
                          className="color-gray"
                          style={{ marginRight: "10px" }}
                        >
                          APR
                        </span>
                        <p className="mb-0">
                          {parseFloat(_rewardDataStake ? getApr() : 0).toFixed(
                            2
                          ) || 0}
                          %{/* <span className="text-uppercase">BNB</span> */}
                        </p>
                      </div>
                    </div>
                    <div className={style.form_stake}>
                      <div className="my-3 d-flex flex-column justify-content-between">
                        <input
                          type="number"
                          placeholder="0.00"
                          className="flex-grow-1"
                          value={inputValueWithdraw}
                          onChange={stackhandleInputChangeWithdraw}
                        />
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center gap-2">
                            <button
                              className="bg-white"
                              onClick={() => handlePercentageClickWithdraw(10)}
                            >
                              10%
                            </button>
                            <button
                              className="bg-white"
                              onClick={() => handlePercentageClickWithdraw(25)}
                            >
                              25%
                            </button>
                            <button
                              className="bg-white"
                              onClick={() => handlePercentageClickWithdraw(50)}
                            >
                              50%
                            </button>
                            <button
                              className="bg-white"
                              onClick={() => handlePercentageClickWithdraw(75)}
                            >
                              75%
                            </button>
                          </div>
                          <div>
                            {" "}
                            <button
                              className={`btn1 ${style.max_btn}`}
                              onClick={() => handlePercentageClickWithdraw(100)}
                            >
                              Max
                            </button>
                          </div>
                        </div>
                      </div>
                      {/* <button className=" py-3 w-100" onClick={openConnectModal}>connect</button> */}
                      {isConnected && address ? (
                        <Box>
                          {parseFloat?.(inputValueWithdraw) >
                          parseFloat?.(unlockedBalance) ? (
                            <button className="btn1 w-100 py-3">
                              Insufficient Fund
                            </button>
                          ) : (
                            <Button
                              disabled={
                                parseFloat?.(inputValueWithdraw) > 0 &&
                                 !isLoadingWithdraw
                                  ? false
                                  : true
                              }
                              onClick={async () => {
                                try {
                                  await withdrawContract();
                                  setInputValueWithdraw(0)
                                } catch (error) {
                                  //console.log(error);
                                }
                              }}
                              sx={{
                                gap: "10px !important",
                                "&.Mui-disabled": {
                                  cursor: "not-allowed !important",
                                  pointerEvents: "auto !important",
                                },
                                backgroundColor: "var(--main-color)",
                                fontSize: "14px",
                                fontFamily: "var(--font-pop)",
                                fontWeight: "700",
                                color: "var(--light)",
                                borderRadius: "12px",
                              }}
                              className="btn1 w-100 py-3"
                            >
                              {(
                                isLoadingWithdraw) && (
                                <Loader color="#423A2A" />
                              )}
                              Withdraw
                            </Button>
                          )}
                        </Box>
                      ) : (
                        <button
                          onClick={openConnectModal}
                          className="btn1 w-100 py-3"
                        >
                          Connect wallet
                        </button>
                      )}
                    </div>
                  </div>
                )
                // {/* End widthdraw code  */}
              }
            </div>
          </div>
          {/* End left stacking code */}
        {/* </div> */}
      </div>
      <NewFooter/>
    </main>
  );
}
